export default __webpack_public_path__ + "static/personal_chef_event-5608a4c520d652a52f27b07cbf980792.png";